import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Featuresrealestate() {
  return (
    <section className="tabing_section features_real_estate p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} className="">
            <h3 className="h3_head">
              Exclusive <span>Features for Effective</span> Real Estate
              Application Development
            </h3>
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p>
              Our expert team of app developers specializes in building a fully
              loaded app, providing users with the tools they need to navigate
              the market effortlessly.
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Real Estate User App">
              <Row className="mt-3 mt-md-5">
                <Col xs={12} md={8} lg={7} xl={6} xxl={6}>
                  <div className="features-blue-box">
                    <div className="features-scroll">
                      <div className="feature-flex">
                        <div className="title">01</div>
                        <div className="title-content">
                          <h6>Smooth Social Login</h6>
                          <p>
                            Allow users to easily sign in through multiple
                            channels such as Facebook, Google, LinkedIn, and
                            Email.
                          </p>
                        </div>
                      </div>
                      <div className="feature-flex">
                        <div className="title">02</div>
                        <div className="title-content">
                          <h6>Smart Search & Filtering Options</h6>
                          <p>
                            Deliver advanced capabilities for users to search
                            and refine their property selections by location,
                            square footage, type, pricing, and other relevant
                            factors.
                          </p>
                        </div>
                      </div>
                      <div className="feature-flex">
                        <div className="title">03</div>
                        <div className="title-content">
                          <h6>Easy Appointment Scheduling</h6>
                          <p>
                            Allow users to effortlessly book appointments for
                            property viewings with their chosen realtors or
                            brokers at their convenience.
                          </p>
                        </div>
                      </div>
                      <div className="feature-flex">
                        <div className="title">04</div>
                        <div className="title-content">
                          <h6>Flexible Payment Solutions</h6>
                          <p>
                            Integrate trusted payment gateways to give users the
                            freedom to pay for their selected properties through
                            multiple convenient options.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col
                  xs={12}
                  md={4}
                  lg={5}
                  xl={5}
                  xxl={5}
                  className="offset-xl-1 text-center"
                >
                  <div className="features-img">
                    <StaticImage
                      src="../../../images/solution/real-estate-updated/features_img.webp"
                      alt="tekrevol_web"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={425}
                      height={825}
                    />
                  </div>
                </Col>
              </Row>
            </Tab>
            <Tab eventKey="2" title="Admin Panel">
              <Row className="mt-3 mt-md-5">
                <Col xs={12} md={8} lg={7} xl={6} xxl={6}>
                  <div className="features-blue-box">
                    <div className="features-scroll">
                      <div className="feature-flex">
                        <div className="title">01</div>
                        <div className="title-content">
                          <h6>Streamlined User Management</h6>
                          <p>
                            Our solution provides a centralized dashboard for
                            managing users, enabling you to maintain oversight
                            and control with ease and efficiency.
                          </p>
                        </div>
                      </div>
                      <div className="feature-flex">
                        <div className="title">02</div>
                        <div className="title-content">
                          <h6>Data-Driven Property Administration</h6>
                          <p>
                            Admins may perform property management
                            responsibilities more efficiently by leveraging
                            actionable data insights to direct decisions.
                          </p>
                        </div>
                      </div>
                      <div className="feature-flex">
                        <div className="title">03</div>
                        <div className="title-content">
                          <h6>Effective Revenue Tracking</h6>
                          <p>
                            Achieve a smooth financial workflow by precisely
                            tracking revenue, enabling better management of
                            resources and improved fiscal performance.
                          </p>
                        </div>
                      </div>
                      <div className="feature-flex">
                        <div className="title">04</div>
                        <div className="title-content">
                          <h6>Strategic Promotions</h6>
                          <p>
                            Create impactful marketing campaigns by implementing
                            flexible offers and discounts that resonate with
                            your audience and drive engagement.
                          </p>
                        </div>
                      </div>
                      <div className="feature-flex">
                        <div className="title">05</div>
                        <div className="title-content">
                          <h6>Flexible Subscription Management</h6>
                          <p>
                            Admins have full control over subscription plans,
                            allowing for easy adjustments—adding, deleting, or
                            editing subscriptions to meet changing user needs.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col
                  xs={12}
                  md={4}
                  lg={5}
                  xl={5}
                  xxl={5}
                  className="offset-xl-1 text-center"
                >
                  <div className="features-img">
                    <StaticImage
                      src="../../../images/solution/real-estate-updated/features_img.webp"
                      alt="tekrevol_web"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={425}
                      height={825}
                    />
                  </div>
                </Col>
              </Row>
            </Tab>
            <Tab eventKey="3" title="Real Estate Agent App">
              <Row className="mt-3 mt-md-5">
                <Col xs={12} md={8} lg={7} xl={6} xxl={6}>
                  <div className="features-blue-box">
                    <div className="features-scroll">
                      <div className="feature-flex">
                        <div className="title">01</div>
                        <div className="title-content">
                          <h6>Organized Lead Tracking</h6>
                          <p>
                            Agents can effortlessly manage their leads through
                            our app, providing a clear and organized approach to
                            nurturing potential clients.
                          </p>
                        </div>
                      </div>
                      <div className="feature-flex">
                        <div className="title">02</div>
                        <div className="title-content">
                          <h6>Instant Connectivity with Lead</h6>
                          <p>
                            Agents can effortlessly communicate with potential
                            clients directly through our residential property
                            apps, ensuring timely responses.
                          </p>
                        </div>
                      </div>
                      <div className="feature-flex">
                        <div className="title">03</div>
                        <div className="title-content">
                          <h6>Effortless Property Oversight</h6>
                          <p>
                            Our app enhances property management by simplifying
                            tasks for agents, enabling them to oversee and
                            maintain their listings with ease.
                          </p>
                        </div>
                      </div>
                      <div className="feature-flex">
                        <div className="title">04</div>
                        <div className="title-content">
                          <h6>Latest Activity Overview</h6>
                          <p>
                            Keep agents informed with a comprehensive snapshot
                            of recent activities, empowering them to remain
                            proactive and responsive in their efforts.
                          </p>
                        </div>
                      </div>
                      <div className="feature-flex">
                        <div className="title">05</div>
                        <div className="title-content">
                          <h6>Flexible Property Listing Control</h6>
                          <p>
                            With our app, agents enjoy the convenience of easily
                            adding or deleting properties from their listings,
                            keeping their inventory accurate and relevant.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col
                  xs={12}
                  md={4}
                  lg={5}
                  xl={5}
                  xxl={5}
                  className="offset-xl-1 text-center"
                >
                  <div className="features-img">
                    <StaticImage
                      src="../../../images/solution/real-estate-updated/features_img.webp"
                      alt="tekrevol_web"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={425}
                      height={825}
                    />
                  </div>
                </Col>
              </Row>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </section>
  );
}

export default Featuresrealestate;
